import React, {useEffect, useState, useRef} from 'react';
import {
  IonGrid,
  IonCard,
  IonCardContent,
  IonText,
  IonRow,
  IonCol,
  IonImg
} from "@ionic/react";
import './PostsContainer.css';
import { set } from '../../services/storage.service';
import { Capacitor } from '@capacitor/core';
import { useHistory} from "react-router-dom";


export const Videos = (props: {
  listOfPosts: any;
  totPages: number;
  handleClickNextPage: any;
}) => {
  const platform = Capacitor.getPlatform();
  const history = useHistory();
  var api: any = useRef<boolean>(false);
  let url: string = "";
  const [type,setType] = useState("");
 
  useEffect( () => {
    async function launchFullscreen(): Promise<void>  {
      //set type and set api etc
      //await set('url', url);
      await set('api', api.current ? "true" : "false");
      history.push('/learn');
      console.log("learn");
      history.push('/fullscreen');
    }
      if(type.length >  0) launchFullscreen();
  },[ api, platform, history, type]);

  function launchPlayer(senturl:string){
      url = senturl;
      //console.log(senturl + "" + url);
      set('url', url).then(()=>{
        console.log(senturl);
        let someNum = Math.random();
        setType(someNum.toString());
        console.log(type);
      });
      
  }
  return (
    <IonGrid>
       <IonRow>
      {
      //Posty = listOFPosts.data
      props.listOfPosts.map(
        (
          post: {
            video_title: string,
            video_link: string,
            video_description: string,
            thumb_link: string,
            video_length: number
          },
          index: string | number | null | undefined
        ) => (
          
            <IonCol onClick={(e)=>launchPlayer(post.video_link)} key={index} style={{padding:'10px'}} size='12' size-sm='4'>
              <IonCard>
                <IonCardContent class="listitem" >
                    {(function() { //check to see if the toggle is applied
                        if(post.thumb_link){//optional rows.
                            return(
                                <IonImg src={post.thumb_link}/>
                            )
                        }
                    })()}   
                      <IonText class="movietitle" style={{padding:'10px 10px 0px 10px'}}>{post.video_title}</IonText>
                      <IonText style={{padding:'0px 10px 10px 10px',display:'block'}}>{post.video_description}</IonText>
                      <IonText style={{padding:'10px',display:'block'}}>{post.video_length}</IonText>
                   
                  </IonCardContent>
                    </IonCard>
              </IonCol>
          
        )
      )}
       </IonRow>
    </IonGrid>
  );
};
